import { CacheClass } from 'cache/cache'

import { DIFF_TIMESTAMP, SESSION_CACHE_KEY } from '../constants'

export const sessionCache = new CacheClass({
	cacheKey: SESSION_CACHE_KEY,
	maxDiffTimestamp: DIFF_TIMESTAMP,
})
